var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crpg-o-news-detail"},[_c('CMS',{attrs:{"contents_type":"news","view_type":"detail"},on:{"completeCMS":_vm.loadingHide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }